import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const southTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'South Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in South Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_south_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving South Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in South Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     upscale neighborhoods and waterfront properties of <strong>South Tampa</strong>. 
     From the grand oaks lining Bayshore Boulevard to the mature trees shading 
     premium homes throughout the peninsula, this area demands precision work 
     and a professional team that respects high value properties. When those 
     trees become hazards, we handle it with the care the job requires.`,

    `We specialize in <strong>precision tree removal and trimming on premium 
     residential properties</strong> large overhanging limbs near luxury homes 
     and pools, storm damaged trees, canopy reductions that preserve the look of 
     your landscape while eliminating risk, and tight lot removals in densely 
     built neighborhoods. We protect your property throughout every phase.`,

    `<strong>Sam's Tree Service</strong> provides trusted, professional tree care 
     throughout <strong>South Tampa</strong> and the surrounding 
     <strong>Tampa Bay waterfront</strong> communities keeping your property 
     safe, beautiful, and storm ready all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'South Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SouthTampa = () => <LocationPage config={southTampaConfig} />;
export default Services_SouthTampa;
